import { gql } from '@apollo/client'
import { head } from 'ramda'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

export const CONFIG_NAME = 'availability_status_source'

const Context = React.createContext([])
const { Provider } = Context
export const useConfigState = () => React.useContext(Context)
export const useConfig = () => useConfigState()?.config

const QUERY = gql`
  query Configs($name: String) {
    configs(filter: { name: $name }) {
      id
      name
      value
      updatedAt
      insertedAt
    }
  }
`

// Config `availability_status_source` may not exist yet for this project (never configured):
// `configs` then returns an empty list and `config` resolves to `undefined`, which
// EditConfigForm treats as "no checkbox selected" instead of failing to load.
const ConfigLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { name: CONFIG_NAME },
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={{ ...data, config: head(data?.configs || []) }}>{children}</Provider>
    </StatePresenter>
  )
}

export default ConfigLoader
